import { render, staticRenderFns } from "./RelativeTime.vue?vue&type=template&id=18931966&scoped=true&"
import script from "./RelativeTime.vue?vue&type=script&lang=js&"
export * from "./RelativeTime.vue?vue&type=script&lang=js&"
import style0 from "./RelativeTime.vue?vue&type=style&index=0&id=18931966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18931966",
  null
  
)

export default component.exports